import { BMotion2 } from './BMotion2';
import { Point } from '../Misc/Utils';
import { BMotionType } from './BMotionEnums';
import { Constants } from '../Misc/Constants';
import { PointOps } from '../Graphics/PointOps';
import { KeyFrame } from '../KeyFrame/KeyFrame';

interface TranslateKeyFrame extends KeyFrame{
    centre: Point
}

export class Translate extends BMotion2{
    readonly TYPE: BMotionType = BMotionType.TRANS

    constructor(curStartPoint: Point){
        super();
        this.createNewKeyFrame(0, [curStartPoint[0],curStartPoint[1]]);
        console.log("const added key frame as "+curStartPoint);
        this.prepare();
    }

    interpolate(interpolant : number, prev: TranslateKeyFrame, next: TranslateKeyFrame) : Point{
        return PointOps.interpolate(
            prev.centre,
            next.centre,
            interpolant);
    }

    //override
    protected resetComputedVal(){
        var firstPoint = (this.keyFrames.get(0) as TranslateKeyFrame).centre;
        this._computedVal = [firstPoint[0], firstPoint[1]];
    }

    protected updateKeyFrameVal(frameNumber: number, newValue: Array<number>): void{
        //Parent checks if frame is available before call this method. So key frame is guaranteed to be available.
        (this.keyFrames.get(frameNumber) as TranslateKeyFrame).centre = [newValue[0], newValue[1]];
        //console.log("setting kf val:"+newValue);
    }

    protected createNewKeyFrame(frame: number, newValue: Array<number>): void{
        var centre = [newValue[0], newValue[1]] as Point;
        var interpolate = true;
        let keyFrameData : TranslateKeyFrame = {centre, frame, interpolate}
        this.keyFrames.add(frame, keyFrameData);
        console.log("added new translate key frame: f:"+frame+" c:"+centre);
    }

    clone(): BMotion2{
        var startPoint = this.keyFrames.get(0) as TranslateKeyFrame;
        var clone = new Translate(startPoint.centre)
        super.duplicate(clone);
        for(var keyFrame of this.keyFrames.getKeys()){
            var tkf = this.keyFrames.get(keyFrame) as TranslateKeyFrame;
            clone.updateKeyFrame(keyFrame, tkf.centre);
        }
        return clone;
    }
}